import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { LoginService } from '../services/login.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss']
})
export class MyAccountComponent implements OnInit {
  userDetails: any;

  constructor(private router:Router,private loginService:LoginService, private toastr : ToastrService) { }

  ngOnInit(): void {
    this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
  }
  statement() {
    this.router.navigate(['statement'])
  }
  profitLoss() {
    this.router.navigate(['eventpl'])
  }
  info() {
    this.router.navigate(['info'])
  }
  history() {
    this.router.navigate(['history'])
  }
  activity() {
    this.router.navigate(['activity'])
  }
  rollComission() {
    this.router.navigate(['rollComission'])
  }

  logoutUser() {
    let data = {}
    this.loginService.logoutUser(data).subscribe(result => {
      if (result.status == true) {
        this.toastr.success(result.msg, '', {
          positionClass: 'toast-top-center',
          timeOut: 2000
        })
        this.loginService.clearLocalStorage()
        this.router.navigate(['openDashboard']);
        window.location.reload();
        window.location.replace('openDashboard');
      } else {
        this.toastr.error(result.msg, '', {
          positionClass: 'toast-top-center',
          timeOut: 5000
        });
        this.loginService.clearLocalStorage()
        this.router.navigate(['openDashboard']);
        window.location.reload();
        window.location.replace('openDashboard');
      }
    })


  }
}
